import React, { Component } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CircularProgress,
    InputAdornment, List, ListItem, ListItemText, TextField
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@mui/styles";
import { Product } from "../../../classes/types/product/product";
import { Filter, FilterValue } from "../../../classes/types/product/product";
import "./filterPage.css";
import deepCopy from "../../../classes/utilities/deepcopy";

interface props {
    products: Array<Product>,
    loading: boolean,
    onProductsFiltered: (productsToView: Array<Product>) => any,
    brand?: boolean,
    category?: boolean,
    subCategory?: boolean,
    availability?: boolean,
    selectedCategory?: string,
    price?: boolean,
    isLogged: boolean,
}

interface state {
    filters: Array<Filter>,
    completeFilters: Array<Filter>,
    availability: boolean,
    unavailable: boolean,
    productsToView: Array<Product>,
    priceFilter1: boolean,
    priceFilter2: boolean,
    priceFilter3: boolean,
    priceFilter4: boolean,
    priceFilter5: boolean,
    priceFilterAll: boolean,
    priceMax: number,
    priceMin: number,
    personalizedPrice: boolean,
    scrollY: number,
    currentHeight: number,
}

const useStyles = makeStyles({
    paper: {
        width: "300px",
        color: 'black',
        borderRight: "none",
    },
    nested: {
        paddingLeft: "60px",
    },
    root: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    label: {

        fontSize: '0.875rem',
        fontWeight: 'bold'
    }
});


export default class FilterPage extends Component<props, state> {
    constructor(props: props) {
        super(props);
        this.state = {
            filters: new Array<Filter>(),
            availability: false,
            unavailable: false,
            productsToView: new Array<Product>(),
            priceFilter1: false,
            priceFilter2: false,
            priceFilter3: false,
            priceFilter4: false,
            priceFilter5: false,
            priceFilterAll: true,
            priceMax: 0,
            priceMin: 0,
            personalizedPrice: false,
            completeFilters: new Array<Filter>(),
            scrollY: 0,
            currentHeight: 0,
        }
        // window.addEventListener("scroll", (event) => {
        //    var verticalScroll = window.scrollY;
        //    var maxHeight = Math.max( document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
        //     this.setState({
        //         scrollY: verticalScroll,
        //         currentHeight: maxHeight,
        //     })
        // }, false);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll, false);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll, false);
    }

    handleScroll = () => {
        const verticalScroll = window.scrollY;
        const maxHeight =
            Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            ) - window.innerHeight;

        this.setState({
            scrollY: verticalScroll,
            currentHeight: maxHeight,
        });
    };

    componentDidUpdate(prevProps: Readonly<props>, prevState: Readonly<state>, snapshot?: any) {
        if (prevProps.products !== this.props.products || this.props.loading !== prevProps.loading) {
            this.setState({
                filters: this.populateFilters(this.props.products),
                completeFilters: this.populateFilters(this.props.products),
                productsToView: this.props.products
            })
        }
    }

    onPriceFilterChange = (filterName: string) => {
        switch (filterName) {
            case 'Fino a 50 €': {
                this.setState({
                    priceFilter1: true,
                    priceFilter2: false,
                    priceFilter3: false,
                    priceFilter4: false,
                    priceFilter5: false,
                    priceFilterAll: false,
                }, () => this.filterProducts())
                break;
            }
            case '50 a 100 €': {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: true,
                    priceFilter3: false,
                    priceFilter4: false,
                    priceFilter5: false,
                    priceFilterAll: false,
                }, () => this.filterProducts())
                //statements;
                break;
            }
            case '100 a 200 €': {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: false,
                    priceFilter3: true,
                    priceFilter4: false,
                    priceFilter5: false,
                    priceFilterAll: false,
                }, () => this.filterProducts())
                //statements;
                break;
            }
            case '200 a 500 €': {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: false,
                    priceFilter3: false,
                    priceFilter4: true,
                    priceFilter5: false,
                    priceFilterAll: false,
                }, () => this.filterProducts())
                //statements;
                break;
            }
            case '500 € e più': {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: false,
                    priceFilter3: false,
                    priceFilter4: false,
                    priceFilter5: true,
                    priceFilterAll: false,
                }, () => this.filterProducts())
                //statements;
                break;
            }
            case 'Tutti': {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: false,
                    priceFilter3: false,
                    priceFilter4: false,
                    priceFilter5: false,
                    priceFilterAll: true,
                }, () => this.filterProducts())
                //statements;
                break;
            }
            default: {
                this.setState({
                    priceFilter1: false,
                    priceFilter2: false,
                    priceFilter3: false,
                    priceFilter4: false,
                    priceFilter5: false,
                    priceFilterAll: true,
                }, () => this.filterProducts())
                //statements;
                break;
            }
        }
    }

    onPriceMaxChange = (e: any) => {
        this.setState({
            priceMax: e.target.value
        })
    }

    onPriceMinChange = (e: any) => {
        this.setState({
            priceMin: e.target.value
        })
    }

    onPriceMaxBlur = (e: any) => {
        if (e.target.value === '' || e.target.value.includes('-')) {
            this.setState({
                priceMax: 0
            })
        }
    }

    onPriceMinBlur = (e: any) => {
        if (e.target.value === '' || e.target.value.includes('-')) {
            this.setState({
                priceMin: 0
            })
        }
    }

    onPersonalizedPriceFilter = () => {
        this.setState({
            personalizedPrice: true,
            priceFilter1: false,
            priceFilter2: false,
            priceFilter3: false,
            priceFilter4: false,
            priceFilter5: false,
            priceFilterAll: true,
        }, () => this.filterProducts())
    }

    onAvailabilityCheckChange = () => {
        this.setState({
            availability: !this.state.availability,
        }, () => this.filterProducts())
    }

    onUnavailableCheckChange = () => {
        this.setState({
            unavailable: !this.state.unavailable,
        }, () => this.filterProducts())
    }

    //creazione dei filtri
    populateFilters = (products: Array<Product>): Array<Filter> => {
        debugger;
        let newFilters: Array<Filter> = new Array<Filter>();
        products.forEach((product) => {
            //filtro marca
            if (product.maker && product.maker.trim() !== '' && this.props.brand !== false) {
                let filterIndex: number = -1;
                newFilters.every((filter, index) => {
                    if (filter.name === "Marca") {
                        filterIndex = index;
                        return false;
                    } else {
                        return true;
                    }
                });
                if (filterIndex !== -1) {
                    let filterValueExists: boolean = false;
                    // Check if filter value exists
                    newFilters[filterIndex].values.every((filterValue) => {
                        if (filterValue.value === product.maker) {
                            filterValueExists = true;
                            return false;
                        } else {
                            return true;
                        }
                    });
                    if (!filterValueExists) {
                        let newFilterValue: FilterValue = new FilterValue();
                        newFilterValue.active = false;
                        newFilterValue.value = product.maker;
                        newFilters[filterIndex].values.push(newFilterValue);
                    }
                } else {
                    let newFilter: Filter = new Filter();
                    newFilter.name = "Marca";
                    let newFilterValue: FilterValue = new FilterValue();
                    newFilterValue.active = false
                    newFilterValue.value = product.maker;
                    newFilter.values.push(newFilterValue);
                    newFilters.push(newFilter);
                }

            }
            //filtro categoria
            if (product.categories && product.categories.length > 0) {
                if (this.props.category !== false) {
                    let filterIndex2: number = -1;
                    newFilters.every((filter, index) => {
                        if (filter.name === "Categoria") {
                            filterIndex2 = index;
                            return false;
                        } else {
                            return true;
                        }
                    });
                    if (filterIndex2 !== -1) {
                        product.categories.forEach((category) => {
                            if (!category.isChildOfAnyCategory) {
                                let filterValueCategoryExists: boolean = false;
                                newFilters[filterIndex2].values.every((filterValue) => {
                                    if (filterValue.value === category.name) {
                                        filterValueCategoryExists = true;
                                        return false;
                                    } else {
                                        return true;
                                    }
                                })
                                if (!filterValueCategoryExists) {
                                    let newFilterValue: FilterValue = new FilterValue();
                                    newFilterValue.active = false;
                                    newFilterValue.value = category.name;
                                    newFilters[filterIndex2].values.push(newFilterValue);
                                }
                            }
                        });
                    } else {
                        let newFilter2: Filter = new Filter();
                        newFilter2.name = "Categoria";
                        product.categories.forEach((category) => {
                            if (!category.isChildOfAnyCategory) {
                                let newFilterValue: FilterValue = new FilterValue();
                                newFilterValue.active = false;
                                newFilterValue.value = category.name;
                                newFilter2.values.push(newFilterValue);
                            }
                        });
                        newFilters.push(newFilter2);
                    }
                }
                //filtro sottocategoria
                if (this.props.subCategory !== false) {

                    let filterIndex2: number = -1;
                    newFilters.every((filter, index) => {
                        if (filter.name === "SottoCategoria") {
                            filterIndex2 = index;
                            return false;
                        } else {
                            return true;
                        }
                    });
                    if (filterIndex2 !== -1) {
                        product.categories.forEach((category) => {
                            if (category.isChildOfAnyCategory) {
                                let filterValueCategoryExists: boolean = false;
                                newFilters[filterIndex2].values.every((filterValue) => {
                                    if (filterValue.value === category.name) {
                                        filterValueCategoryExists = true;
                                        return false;
                                    } else {
                                        return true;
                                    }
                                })
                                if (!filterValueCategoryExists) {
                                    let newFilterValue: FilterValue = new FilterValue();
                                    newFilterValue.active = false;
                                    newFilterValue.value = category.name;
                                    newFilters[filterIndex2].values.push(newFilterValue);
                                }
                            }
                        });
                    } else {
                        let newFilter2: Filter = new Filter();
                        newFilter2.name = "SottoCategoria";
                        product.categories.forEach((category) => {
                            if (category.isChildOfAnyCategory) {
                                let newFilterValue: FilterValue = new FilterValue();
                                newFilterValue.active = false;
                                newFilterValue.value = category.name;
                                newFilter2.values.push(newFilterValue);
                            }
                        });
                        newFilters.push(newFilter2);
                    }
                }
            }


            /* product.components.forEach((component) => {
                 // Check if filter name exists
                 let filterIndex: number = -1;
                 newFilters.every((filter, index) => {
                     if (filter.name === component.name) {
                         filterIndex = index;
                         return false;
                     } else {
                         return true;
                     }
                 });
                 if (filterIndex !== -1) {
                     let filterValueExists: boolean = false;
                     // Check if filter value exists
                     newFilters[filterIndex].values.every((filterValue) => {
                         if (filterValue.value === component.value) {
                             filterValueExists = true;
                             return false;
                         } else {
                             return true;
                         }
                     });
                     if (!filterValueExists) {
                         let newFilterValue: FilterValue = new FilterValue();
                         if(lastURLSegment.replace(/\s/g, "").toUpperCase() === component.value.replace(/\s/g, "").toUpperCase()){
                             newFilterValue.active = true;
                         } else {
                             newFilterValue.active = false;
                         }
                         newFilterValue.value = component.value;
                         newFilters[filterIndex].values.push(newFilterValue);
                     }
                 } else {
                     let newFilter: Filter = new Filter();
                     newFilter.name = component.name;
                     let newFilterValue: FilterValue = new FilterValue();
                     if(lastURLSegment.replace(/\s/g, "").toUpperCase() === component.value.replace(/\s/g, "").toUpperCase()){
                         newFilterValue.active = true;
                     } else {
                         newFilterValue.active = false;
                     }
                     newFilterValue.value = component.value;
                     newFilter.values.push(newFilterValue);
                     newFilters.push(newFilter);
                 }
                 });*/
        });
        //ordine filtro per nome
        newFilters.forEach((filter, index) => {
            filter.values.sort(function (a, b) {
                return a.value.localeCompare(b.value);
            });
            if (filter.values.length < 1) {
                newFilters.splice(index, 1);
            }
        })
        return newFilters;
    }

    setFilterValueActive = (filterIndex: number, filterValueIndex: number, newValue: boolean) => {
        let filtersCopy: Array<Filter> = this.state.filters.slice();
        filtersCopy[filterIndex].values[filterValueIndex].active = newValue;
        this.setState({
            filters: filtersCopy,
        }, () => this.filterProducts());
    }

    filterProducts = () => {
        let productsArray: Array<Product> = this.props.products.slice();
        let newProductArray: Array<Product> = new Array<Product>();
        let hasActiveFilter = false;
        let selectedChildCategories = new Array<FilterValue>();
        let hasSubCategoryFilter = false;
        productsArray.forEach((product) => {
            let productNotToAdd = false;
            if (!this.state.priceFilterAll) {
                if (this.state.priceFilter1 && product.price <= 50) {

                } else if (this.state.priceFilter2 && product.price >= 50 && product.price <= 100) {

                } else if (this.state.priceFilter3 && product.price >= 100 && product.price <= 200) {

                } else if (this.state.priceFilter4 && product.price >= 200 && product.price <= 500) {

                } else if (this.state.priceFilter5 && product.price >= 500) {

                } else {
                    productNotToAdd = true
                }
            } else if (this.state.personalizedPrice) {
                if (product.price < this.state.priceMin || product.price > this.state.priceMax) {
                    productNotToAdd = true
                }
            }
            if (this.state.unavailable) {
                if (product.stock1 > 0) {
                    productNotToAdd = true;
                }
            } else if (this.state.availability) {
                if (product.stock1 <= 0) {
                    productNotToAdd = true;
                }
            }
            this.state.filters.forEach((filter) => {
                if (this.props.brand !== false) {
                    if ("Marca" === filter.name) {
                        // get current active filter value
                        let productFiltered = false;
                        let currentFilterActive = false;
                        let found = false;
                        filter.values.every((filterValue) => {
                            if (filterValue.active) {
                                currentFilterActive = true;
                                if (filterValue.value === product.maker) {
                                    productFiltered = true;
                                    found = true;
                                }
                            }
                            return !found;

                        });
                        if (!productFiltered && currentFilterActive) {
                            productNotToAdd = true
                        }

                    }
                }
                if (this.props.subCategory !== false) {
                    if ("SottoCategoria" === filter.name) {
                        // get current active filter value
                        let productFiltered = false;
                        let currentFilterActive = false;
                        let found = false;
                        filter.values.every((filterValue) => {
                            if (filterValue.active) {
                                hasSubCategoryFilter = true;
                                currentFilterActive = true;
                                product.categories.every((category) => {
                                    if (category.isChildOfAnyCategory) {
                                        if (filterValue.value === category.name) {
                                            productFiltered = true;
                                            found = true;
                                        }
                                        return false;
                                    }
                                    return !found;

                                })
                            }
                            return !found;
                        });
                        if (!productFiltered && currentFilterActive) {
                            productNotToAdd = true
                        }

                    }
                }
                if (this.props.category !== false) {
                    if ("Categoria" === filter.name) {
                        // get current active filter value
                        let productFiltered = false;
                        let currentFilterActive = false;
                        let found = false;
                        filter.values.every((filterValue) => {
                            if (filterValue.active) {
                                hasActiveFilter = true
                                currentFilterActive = true;
                                product.categories.every((category) => {
                                    if (filterValue.value === category.name) {
                                        if (!hasSubCategoryFilter) {
                                            productFiltered = true;
                                        }
                                        found = true;
                                        product.categories.forEach((categoryFull) => {
                                            if (categoryFull.isChildOfAnyCategory) {
                                                let exist = false;
                                                selectedChildCategories.forEach((child) => {
                                                    if (child.value === categoryFull.name) {
                                                        exist = true;
                                                    }
                                                })
                                                if (!exist) {
                                                    let categoryChildFilterValue = new FilterValue();
                                                    categoryChildFilterValue.value = categoryFull.name;
                                                    selectedChildCategories.push(categoryChildFilterValue);
                                                }
                                            }
                                        })
                                        return false;
                                    } else if (category.children !== undefined && category.children.length > 0) {
                                        category.children.every((childCategory) => {
                                            if (filterValue.value === childCategory.name) {
                                                if (!hasSubCategoryFilter) {
                                                    productFiltered = true;
                                                }
                                                found = true;
                                                return false
                                            }
                                            return true
                                        })
                                    }
                                    return !found;

                                })
                            }
                            return !found;

                        });
                        if ((!productFiltered && currentFilterActive && !hasSubCategoryFilter)) {
                            productNotToAdd = true
                        }
                    }
                }
            });
            if (!productNotToAdd) {
                newProductArray.push(product);
            }
        });
        let filtersCopy = this.state.filters.slice();
        if (hasActiveFilter) {
            filtersCopy.forEach((filter: Filter) => {
                if (filter.name === "SottoCategoria") {
                    filter.values.forEach((value) => {
                        selectedChildCategories.every((selectedChild) => {
                            if (selectedChild.value === value.value) {
                                selectedChild.active = value.active
                                return false;
                            }
                            return true;
                        })
                    })
                    filter.values = selectedChildCategories;
                }
            })

        } else {
            let completeFilterCopy = deepCopy(this.state.completeFilters);
            filtersCopy.every((filter: Filter) => {
                if (filter.name === "SottoCategoria") {
                    completeFilterCopy.forEach((completeFilter: Filter) => {
                        if (completeFilter.name === "SottoCategoria") {
                            filter.values.forEach((value) => {
                                completeFilter.values.forEach((child) => {
                                    if (child.value === value.value) {
                                        child.active = value.active
                                    }
                                })
                            })
                            filter.values = completeFilter.values;
                        }
                    })
                    return false;
                }
                return true;
            })
        }
        this.setState({
            personalizedPrice: false,
            filters: filtersCopy,
            productsToView: newProductArray,
        })
        this.props.onProductsFiltered(newProductArray);
    }

    valueLabelFormat = (value: number) => {
        return value;
    }

    valuetext = (value: number) => {
        return `${value} `;
    }

    customFilter = () => {
        const styles = useStyles();

        return (
            <div style={{ marginLeft: "11.5%" }}>
                <h1 className={"filterTitle"}>FILTRI </h1>

                {this.props.loading ? (
                    <div className={"filterLoadingContainer"}>
                        <CircularProgress />
                    </div>
                ) : this.state.filters.length < 1 ? (
                    <div className={"filterEmptyContainer"}>
                        <h3 className={"filterEmptyText"}>Filtri non presenti</h3>
                        <FontAwesomeIcon className={"filterEmptyIcon"} icon={faBoxOpen} />
                    </div>
                ) : (
                    <div
                        className={
                            this.state.currentHeight - this.state.scrollY > 161 ||
                                this.state.scrollY === 0
                                ? this.state.productsToView.length > 2
                                    ? "filterContainer"
                                    : "filterContainer2"
                                : "filterContainer2"
                        }
                    >
                        <List className={"filterList"}>
                            <div
                                className={"filterListContentConatiner"}
                                style={{ overflow: "auto" }}
                            >
                                {this.state.filters.map((filter, filterIndex) => (
                                    <Accordion key={filterIndex} defaultExpanded>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`filter-${filterIndex}-content`}
                                            id={`filter-${filterIndex}-header`}
                                        >
                                            <span className={styles.label}>{filter.name.toUpperCase()}</span>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <div className={"filterTreeItemContentContainer"}>
                                                {filter.values.map((filterValue, filterValueIndex) => (
                                                    <ListItem key={filterValueIndex} className={"filterListItem"}>
                                                        <ListItemText className={"filterListItemTitle"}>
                                                            {filterValue.value}
                                                        </ListItemText>
                                                        <Checkbox
                                                            color={"primary"}
                                                            onChange={(event) =>
                                                                this.setFilterValueActive(
                                                                    filterIndex,
                                                                    filterValueIndex,
                                                                    event.target.checked
                                                                )
                                                            }
                                                            checked={
                                                                this.state.filters[filterIndex].values[filterValueIndex].active
                                                            }
                                                        />
                                                    </ListItem>
                                                ))}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}

                                {this.props.availability === false ? (
                                    ""
                                ) : (
                                    <Accordion defaultExpanded>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <span className={styles.label}>DISPONIBILITÀ</span>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>Disponibili</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={this.onAvailabilityCheckChange}
                                                    checked={this.state.availability}
                                                />
                                            </ListItem>
                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>Non disponibili</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={this.onUnavailableCheckChange}
                                                    checked={this.state.unavailable}
                                                />
                                            </ListItem>
                                        </AccordionDetails>
                                    </Accordion>
                                )}

                                {this.props.price === false ? (
                                    ""
                                ) : (
                                    <Accordion defaultExpanded={false} hidden={!this.props.isLogged}>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <span className={styles.label}>PREZZO</span>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>Fino a 50 €</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("Fino a 50 €")}
                                                    checked={this.state.priceFilter1}
                                                />
                                            </ListItem>

                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>50 a 100 €</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("50 a 100 €")}
                                                    checked={this.state.priceFilter2}
                                                />
                                            </ListItem>

                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>100 a 200 €</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("100 a 200 €")}
                                                    checked={this.state.priceFilter3}
                                                />
                                            </ListItem>

                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>200 a 500 €</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("200 a 500 €")}
                                                    checked={this.state.priceFilter4}
                                                />
                                            </ListItem>

                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>500 € e più</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("500 € e più")}
                                                    checked={this.state.priceFilter5}
                                                />
                                            </ListItem>

                                            <ListItem className={"filterListItemColor"}>
                                                <ListItemText>Tutti</ListItemText>
                                                <Checkbox
                                                    color={"primary"}
                                                    onChange={() => this.onPriceFilterChange("Tutti")}
                                                    checked={this.state.priceFilterAll}
                                                />
                                            </ListItem>

                                            <h3>Prezzo Personalizzato</h3>

                                            <ListItem className={"filterCustomPriceListItem2"}>
                                                <TextField
                                                    label={"Min"}
                                                    id="outlined-start-adornment"
                                                    variant="outlined"
                                                    size="small"
                                                    type="number"
                                                    className={"filterCustomPriceTextInput"}
                                                    value={this.state.priceMin}
                                                    onChange={this.onPriceMinChange}
                                                    onBlur={this.onPriceMinBlur}
                                                    InputProps={{
                                                        inputProps: { max: 9999999, min: 0 },
                                                        startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                                    }}
                                                />

                                                <TextField
                                                    label={"Max"}
                                                    id="outlined-start-adornment"
                                                    variant="outlined"
                                                    size="small"
                                                    type="number"
                                                    value={this.state.priceMax}
                                                    onChange={this.onPriceMaxChange}
                                                    onBlur={this.onPriceMaxBlur}
                                                    InputProps={{
                                                        inputProps: { max: 9999999, min: 0 },
                                                        startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                                    }}
                                                />
                                            </ListItem>

                                            <br />

                                            <div className={"filterCustomPriceButtonContainer"}>
                                                <Button
                                                    disabled={Number(this.state.priceMin) >= Number(this.state.priceMax)}
                                                    onClick={this.onPersonalizedPriceFilter}
                                                    className={"filterCustomPriceButton"}
                                                    variant={"contained"}
                                                    color={"primary"}
                                                >
                                                    Filtra
                                                </Button>
                                            </div>

                                            <br />
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                            </div>
                        </List>
                    </div>
                )}
            </div>
        );
    };

    render() {
        console.log(this.state.scrollY, this.state.currentHeight);
        return (

            <div>
                <this.customFilter />
            </div>
        );
    }

}

